import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import styles from './Features.module.scss';

import Video from '../../util/Video/Video';
import ButtonPill from '../../util/ButtonPill/ButtonPill';

const Features = () => {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useTranslation(['marketing']);

  // Prevent hydration issues by not rendering until client-side
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
  <div className={styles.Features}>
    <div className={styles.Container}>
      <div className={styles.SectionHeadline}>
        <div className={styles.Description}>
          <h3>{t('landing.features.hostEvents.title')}</h3>
          <p className={styles.my2}>
            {t('landing.features.hostEvents.description')}
          </p>
          <div className={styles.button}>
            <ButtonPill type="ButtonBlueWide" link="/features">
              {t('landing.features.hostEvents.learnMore')}
            </ButtonPill>
          </div>
          <div className={styles.FeatureVid}>
            <Video
              sources={[
                {
                  src: '/vid/feature-1.webm',
                  type: 'video/webm; codecs=vp9,vorbis'
                },
                {
                  src: '/vid/feature-1.mp4',
                  type: 'video/mp4'
                }
              ]}
            />
          </div>
        </div>
      </div>
      <div className={styles.SectionHeadline}>
        <div className={cn(styles.Description, styles.Reverse)}>
          <h3>{t('landing.features.payments.title')}</h3>
          <p className={styles.my2}>
            {t('landing.features.payments.description')}
          </p>
          <div className={styles.button}>
            <ButtonPill type="ButtonBlueWide" link="/features">
              {t('landing.features.payments.learnMore')}
            </ButtonPill>
          </div>
          <div className={cn(styles.FeatureVid, styles.vid)}>
            <Video
              sources={[
                {
                  src: '/vid/feature-2.webm',
                  type: 'video/webm; codecs=vp9,vorbis'
                },
                {
                  src: '/vid/feature-2.mp4',
                  type: 'video/mp4'
                }
              ]}
            />
          </div>
        </div>
      </div>
      <div className={styles.SectionHeadline}>
        <div className={styles.Description}>
          <h3>{t('landing.features.relationships.title')}</h3>
          <p className={styles.my2}>
            {t('landing.features.relationships.description')}
          </p>
          <div className={styles.button}>
            <ButtonPill type="ButtonBlueWide" link="/features">
              {t('landing.features.relationships.learnMore')}
            </ButtonPill>
          </div>
          <div className={cn(styles.FeatureVid, styles.WideScreen)}>
            <Video
              sources={[
                {
                  src: '/vid/feature-3.webm',
                  type: 'video/webm; codecs=vp9,vorbis'
                },
                {
                  src: '/vid/feature-3.mp4',
                  type: 'video/mp4'
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  );
};

export default Features;
